import * as React from "react";
import { cn } from "../../lib/utils";

export interface TableDetailPanelProps {
  /**
   * Whether the panel is open
   */
  isOpen: boolean;
  /**
   * Callback to close the panel
   */
  onClose?: () => void;
  /**
   * Content to display in the panel
   */
  children: React.ReactNode;
  /**
   * Custom class name
   */
  className?: string;
  /**
   * Panel width
   */
  width?: string | number;
}

export const TableDetailPanel = React.forwardRef<
  HTMLDivElement,
  TableDetailPanelProps
>(({ isOpen, onClose, children, className, width = "400px" }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "absolute top-0 right-0 h-full bg-white border  border-surface-outline-neutral-muted  transition-transform duration-300 ease-in-out overflow-auto",
        isOpen ? "translate-x-0" : "translate-x-full",
        className
      )}
      style={{ width }}
    >
      {children}
    </div>
  );
});

TableDetailPanel.displayName = "TableDetailPanel";
